import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createSelectors } from './utils/createSelectors';

interface LeadTrackState {
    status: boolean;
}

const useLeadTrackBaseStore = create<LeadTrackState>()(
    persist(
        (_set) => ({
            status: false,
        }),
        {
            name: 'leadTrack-storage',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);

export const useLeadTrackStore = createSelectors(useLeadTrackBaseStore);

export const setLeadTrackStatus = (status: boolean) => {
    useLeadTrackBaseStore.setState((state) => {
        return { ...state, status };
    });
};
